import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
    extends React.InputHTMLAttributes<HTMLInputElement> {
    formik: any,
    name: string
}

const InputFormik = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, ...props }, ref) => {
        return (
            <>
                <input
                    onBlur={props.formik.handleBlur}
                    value={props.formik.values[props.name]}
                    onChange={props.formik.handleChange}
                    type={type}
                    className={cn(
                        "text-black flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
                        className,
                        props.formik.errors[props.name] ? 'focus-visible:ring-red-600' : 'focus-visible:ring-green-600',
                        {
                            'ring-red-600 ring-2': props.formik.touched[props.name] && props.formik.errors[props.name],
                            'ring-green-600 ring-2': props.formik.touched[props.name] && !props.formik.errors[props.name],
                        }
                    )}
                    ref={ref}
                    {...props}
                />
                {
                    (props.formik.touched[props.name] && props.formik.errors[props.name]) &&
                    (
                        <span className="text-sm text-destructive">
                            {props.formik.errors[props.name]}
                        </span>
                    )
                }
            </>
        )
    }
)
InputFormik.displayName = "InputFormik"

export { InputFormik }
